var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.394,
    height: 24.311,
    viewBox: "0 0 25.394 24.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(-1046.811 -2038.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    transform: "translate(1046.811 2038.359)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.394,
    height: 24.311,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 23.894,
    height: 22.811,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M277.186,593.683a3.332,3.332,0,1,1,1.542-2.81",
    transform: "translate(779.172 1454.785)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    transform: "translate(1053.349 2044.439)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.218,
    cy: 1.217,
    rx: 1.218,
    ry: 1.217,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.218,
    cy: 1.217,
    rx: 0.468,
    ry: 0.467,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M5.123,6.142a3.332,3.332,0,1,1,1.542-2.81",
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 1056.923, 2051.322)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 1055.428, 2053.911)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.218,
    cy: 1.217,
    rx: 1.218,
    ry: 1.217,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.218,
    cy: 1.217,
    rx: 0.468,
    ry: 0.467,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M5.123,6.142a3.332,3.332,0,1,1,1.542-2.81",
    transform: "translate(1063.175 2050.228) rotate(-121)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    transform: "translate(1063.897 2047.328) rotate(-121)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.218,
    cy: 1.217,
    rx: 1.218,
    ry: 1.217,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.218,
    cy: 1.217,
    rx: 0.468,
    ry: 0.467,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 1.218,
    cy: 1.217,
    rx: 1.218,
    ry: 1.217,
    transform: "translate(1065.716 2059.153) rotate(-121)",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 1.218,
    cy: 1.217,
    rx: 1.218,
    ry: 1.217,
    transform: "translate(1065.716 2055.811) rotate(-121)",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 1.218,
    cy: 1.217,
    rx: 1.218,
    ry: 1.217,
    transform: "translate(1062.375 2059.153) rotate(-121)",
    fill: "#005682"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStove);
export default __webpack_public_path__ + "static/media/stove.00ab4467e0a57dd61a3724c8068fdc0d.svg";
export { ForwardRef as ReactComponent };